import {useMemo} from 'react';
import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {ThesaurusId, ThesaurusMap, ThesaurusesState} from '../types';
import {selectThesaurus} from '../thesaurusSlice';
import {getDummyThesaurus} from './getDummyThesaurus';

export const useThesaurusMap = (ids: ThesaurusId[]): ThesaurusMap => {
  const thesaurusState: ThesaurusesState = useAppSelector(selectThesaurus);
  return useMemo(() => {
    return ids.reduce<ThesaurusMap>((acc, id) => {
      const thesaurus = thesaurusState[id]?.data;
      assert.soft(
        thesaurus,
        'useThesaurusList: ThesaurusItem list not loaded',
        {
          id,
        },
      );

      return {
        ...acc,
        [id]: thesaurus ?? getDummyThesaurus(id),
      };
    }, {});
  }, [ids, thesaurusState]);
};
